// extracted by mini-css-extract-plugin
export var container = "_di-0";